<fc-footer-ui> </fc-footer-ui>